import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { Role } from '../models/role';
import { TaskRecipient } from '../models/taskRecipient';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class TaskRecipientService {

    controller = 'TaskRecipient';

    constructor(private base: BaseService) { }


    getsNotifications(): Observable<ApiObjectData> {
        return this.base.gets(this.controller + '/GetByUser');
    }

    getRecipientByUserTask(taskId:number){
        return this.base.gets(this.controller+'/GetRecipientByUserTask/'+taskId);
    }

    save(obj:TaskRecipient){
       return this.base.save(this.controller, obj);
    }
}
